export const TAB_NAME = 'employee_costs'
